const utils = require('frontend-controller/lib/utils')

module.exports = {
    config: {
        documentType: 'unknown',
    },
    model: {
        trip: null,
        tripAttributes: null,
        tripReplacements: null,
        invoiceMeta: null,
    },
    methods: {
        sanitizeResourceFilters(storage, resourceFilters, actionKey){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'refreshResources'){
                resourceFilters.type = this.config.documentType || 'unknown'
            }
        },

        formatTimeRange(startTS, endTS, showWeekdays = true){
            let prefix = ''
            if(showWeekdays){
                prefix = 'dddd, '
            }

            const parts = []
            const start = startTS && utils.moment(startTS).format(`${prefix}DD.MM.YYYY`) || false
            const startSlim = startTS && utils.moment(startTS).format(`${prefix}DD.MM.`) || false
            const end = endTS && utils.moment(endTS).format(`${prefix}DD.MM.YYYY`) || false
            const startYear = startTS && utils.moment(startTS).format('YYYY') || false
            const endYear = endTS && utils.moment(endTS).format('YYYY') || false

            if(start){
                if(!end || startYear !== endYear || start === end){
                    parts.push(start)
                } else {
                    parts.push(startSlim)
                }
            }
            if(end && start !== end){
                parts.push('-')
                parts.push(end)
            }

            if(parts.length < 1){
                parts.push('-')
            }

            return parts.join(' ')
        },

        prepare: function(storage, isServer){
            const trip = this.model.trip = (storage.request || {}).trip || {}
            const tripData = trip.data || {}
            const attributes = this.model.tripAttributes = tripData.attributes || {}
            const stages = attributes.tripStages || []
            const firstStage = stages[0]
            const lastStage = stages.length > 1 && stages[stages.length - 1]

            this.model.tripReplacements = {
                reisezeitraum: this.formatTimeRange(attributes.tripStart, attributes.tripEnd),
                reisezeitraumohnewochentage: this.formatTimeRange(attributes.tripStart, attributes.tripEnd, false),
                reiseroute: stages.map(stage => String(stage.title || '').trim()).filter(v => !!v).join(' - '),
                anzahlpersonen: attributes.numberOfPersons || 0,
                bustyp: attributes.vesselType,
                einsatzzeit: [
                    firstStage ? [firstStage.title, firstStage.stage].filter(v => !!v).join(' ') : false,
                    lastStage ? [lastStage.title, lastStage.stage].filter(v => !!v).join(' ') : false,
                ].filter(v => !!v).join(' - '),
                rechnungssumme: `<b>${utils.number.format(attributes.invoiceSumPrice || 0, {
                    min: 0,
                    prefix: '€ ',
                    decimals: 2,
                }, 'float').formatted}</b>`,
            }

            const invoiceMeta = this.model.invoiceMeta = {}
            const sumVat = invoiceMeta.sumVat = {}
            invoiceMeta.sumNet = 0
            invoiceMeta.sumGross = 0

            for (const costCenter of attributes.tripCostCenters || []) {

                const vat = utils.number.round(utils.number.parseFloat(costCenter.vat || 0, 0), 1)
                const vatKey = parseInt(vat * 100) // produces sort order
                let net = costCenter.netPrice
                let gross = costCenter.price

                const vatC = (vat + 100) / 100
                const hasNet   = net > 0
                const hasGross = gross > 0
                if (hasNet && !hasGross) {
                    gross = costCenter.price = net * vatC
                }
                if (hasGross && !hasNet) {
                    net = costCenter.netPrice = gross / vatC
                }

                sumVat[vatKey] = sumVat[vatKey] || {}
                sumVat[vatKey].gross = (sumVat[vatKey].gross || 0) + gross
                sumVat[vatKey].net = (sumVat[vatKey].net || 0) + net
                sumVat[vatKey].vatV = (sumVat[vatKey].vatV || 0) + (gross - net)
                sumVat[vatKey].vat = sumVat[vatKey].vat || vat || 0

                invoiceMeta.sumNet += (net || 0)
                invoiceMeta.sumGross += (gross || 0)
            }

        },
    }
}